module.exports = __webpack_public_path__ + "media/images/clubteam_banner-5a75037c6cc2d044046f31a5901f739c.png";